import React from 'react';
import Banner from '../Components/Pages/Enterprise/Banner';
import Header from '../Components/Shared/Header/Header';
import Slider from '../Components/Shared/LogoSlider/Slider';
import { images } from '../Components/Pages/Home/data';
import Security from '../Components/Pages/Enterprise/Security';
import Prototyping from '../Components/Pages/Home/Prototyping';
import Design from '../Components/Pages/Home/Design';
import Bg from '../Assets/Backgrounds/designEnterprise.webp';
import Customer from '../Components/Pages/Enterprise/Customer';
import Awards from '../Components/Shared/Awards/Awards';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function Enterprise(){
    return(
        <>
        <Header />
        <Banner />
        <Slider 
        list={images}
        />
        <Security />
        <Prototyping styles="reversed-prototyping"
         title="Seamlessly move from prototype to user test to developer handoff"
        desc="Consolidate your tools and give every team the power to problem solve together. Brainstorm, design, prototype, user test and handoff to developers on a single platform, accessible by designers, developers, researchers and stakeholders in a few clicks."
         btn="Request a demo"/>
         <Design 
         backgroundImage={Bg}
         title="Full visibility of new, ongoing and completed projects"
         desc="Whether it's what's new, what's in progress or what's finished, Hostdesign Enterprise centralises all team members activity into one stream, so management can quickly see what's in motion and stay on the same page."
         />
         <Customer />
         <Awards />
         <Start />
         <Footer />
        </>
    )
};
export default Enterprise ;